import React, {useState,useEffect} from 'react';

import './Modal.scss';

const Modal = props => {
    
    return (
        <div className='skrim'>
            <div className={props.className  || 'person-modal'}>
                {props.children}

            </div>
        </div>
        
    )
}

export default Modal;